/// <reference path="../_all.ts" />

module editor {
  'use strict';
  
  declare var ace: any; // Magic

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class EditorCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      'editorService', 
      'CacheFactory',
      '$mdDialog',
      '$q',
      'pageMetaService',
      'debounce',
      '$mdSidenav',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IEditorControllerScope,
      private $timeout: ng.ITimeoutService,
      private editorService: IEditorService,
      private CacheFactory: CacheFactory.ICacheFactory, 
      private $mdDialog: ng.material.IDialogService,
      private $q : ng.IQService,
      private pageMetaService: navigation.IPageMetaService,
      private debounce: navigation.IDebounceService,
      private $mdSidenav: ng.material.ISidenavService
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      
      $scope.supportedLanguages = pglob.RouteData.SupportedLanguages;
      $scope.allTags = null;
      $scope.uploadButtonsBound = false;
      $scope.page='prop';
      
      $scope.isValidFromDateSet = false;
      $scope.validFromDate = null;
      $scope.isValidToDateSet = false;
      $scope.validToDate = null;

      $scope.show = false;
      $scope.showButton = false;
      $scope.editorInstance = null;
      $scope.editorSession = null;
      $scope.routeParameterStack = pglob.RouteData.RouteEntry.RouteParameterStack;      
      $scope.settings = {
        currentLanguage: pglob.RouteData.CurrentLanguage.hl, 
        view: "Source",
        currentContentType: function (ct: ContentType) {
          if (angular.isDefined(ct)) {
            editorService.convertContent($scope.content, ct).then((response) => {
              $scope.content.Content = response.data.Content;
              $scope.content.ContentType = response.data.ContentType;
              if (response.data.ContentType == ContentType.MarkDown) $scope.editorSession.setMode("ace/mode/markdown"); 
              if (response.data.ContentType == ContentType.HTML) $scope.editorSession.setMode("ace/mode/html");
            })
          } else {
            if ($scope.content) return $scope.content.ContentType;
          }
        },
      };

      $scope.permissionValues = [ 
        { id: 0, text: "Jeder", value: null },
        { id: 1, text: "Anonym (Dokustufe 7)", value: "7afbda36-d428-44c8-95e0-1cdc2eb34e7e" },
        { id: 2, text: "Endkunde (Dokustufe 6)", value: "505ba489-8468-408c-8c08-22d335567898" },
        { id: 3, text: "OEM (Dokustufe 5)", value: "975e83a1-ec52-466d-abf9-b830a3bd3694" },
        { id: 4, text: "Händler (Dokustufe 4)", value: "9b09bb8f-5083-4284-a87f-7c8b7db91644" },
        { id: 5, text: "Service (Dokustufe 3)", value: "47ee351f-53f4-4f01-9c0b-0f990fac756f" },
        { id: 6, text: "Vertretungen (Dokustufe 2)", value: "be63256c-eaeb-4a6e-bba1-08dc63e17f52" },
        { id: 7, text: "Verkauf (Dokustufe 1)", value: "d460d559-6c65-4c3d-834b-a14c7f33ef19" },
        { id: 8, text: "Produktion (Dokustufe 0)", value: "be0e28eb-1a45-4546-977b-5498a0f7b28f" }
      ];

      $scope.liveViewContent = "";

      if ($scope.content) {
        $scope.urlPlacehldr = this.getUrlKey($scope.content.ContentMeta.Title);
      }

      $scope.updateLiveView = function (content: Content, type: ContentType) {
        if (content && type && $scope.content.ContentType == ContentType.MarkDown) {
          editorService.convertContent(content, type).then((response) => {
            $scope.liveViewContent = response.data.Content;
          })
        } 
      };

      $scope.changeStatus = function (status: ContentMetaStatus) {
        editorService.changeStatus($scope.content.ContentMeta.Id, status, $scope.currentLanguage).then((response) => {
          $scope.content.ContentMeta.Status = response.data.ContentMeta.Status;
          $scope.content.ContentMeta.ModifiedAt = response.data.ContentMeta.ModifiedAt;
          $scope.content.ContentMeta.ModifiedBy = response.data.ContentMeta.ModifiedBy;
          $scope.content.ContentMeta.PublishedAt   = response.data.ContentMeta.PublishedAt;
          $scope.content.ContentMeta.PublishedBy = response.data.ContentMeta.PublishedBy; 
          $scope.content.ContentMeta.RowVersion = response.data.ContentMeta.RowVersion; 
        });
      }

      $scope.isOpenRight = function () {
        return $mdSidenav('right').isOpen();
      }

      $scope.$watch('content.Content', (newVal, oldVal) => {
        $scope.updateLiveView($scope.content, ContentType.HTML);
      })

      $scope.$watch('content.ContentMeta.Title', (newVal, oldVal) => {
        if ($scope.content && newVal) {
          if ($scope.content.ContentMeta && newVal != oldVal) {
            $scope.urlPlacehldr = this.getUrlKey(newVal.toString());
          }
        }
      }, false)

      var upload = (file : any, type : ContentAttachementType) => {
        var extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        this.editorService.uploadFile(file, type, this.$scope.content.ContentMeta.Id, extension, this.$scope.currentLanguage)
        .then((response) => {          
          this.$scope.content.ContentMeta.RowVersion = response.data.ContentMeta.RowVersion; 
          this.$scope.content.ContentMeta.Image = response.data.ContentMeta.Image;
          this.$scope.content.ContentMeta.Attachment = response.data.ContentMeta.Attachment;          
        });
      }

      $scope.$watch('picFile', (newVal, oldVal) => {
        if (newVal) {
          upload(newVal, ContentAttachementType.ContentImage);
        }
      })

      $scope.$watch('attFile', (newVal, oldVal) => {
        if (newVal) {
          upload(newVal, ContentAttachementType.ContentAttachment);
        }
      })
      
      this.setRequestOnGoing = debounce(this.setRequestOnGoing, 500, false);

      $scope.aceLoaded = (_editor :  AceAjax.Editor) => {
        // Editor part
        $scope.editorInstance = _editor;
        $scope.editorSession = _editor.getSession();

        this.$timeout(() => { $scope.showButton = true; })

        $scope.editorInstance.$blockScrolling = Infinity;
      
        var _renderer : AceAjax.VirtualRenderer = _editor.renderer;
      
        // Options
        $scope.editorSession.setUndoManager(new ace.UndoManager());

        var saveFunction : Function = angular.bind(this, this.saveContent);
        $scope.editorInstance.commands.addCommand({
          name: 'saveFile',
          bindKey: {
            win: 'Ctrl-S',
            mac: 'Command-S',
            sender: 'editor|cli'
          },
          exec: function (env, args, request) { 
            saveFunction();
          }
        });
        
        
        var closeFunction : Function = angular.bind(this, this.closeDialog);
        $scope.editorInstance.commands.addCommand({
          name: 'close',
          bindKey: {
            win: 'Esc',
            mac: 'Esc',
            sender: 'editor|cli'
          },
          exec: function (env, args, request) {
            closeFunction();
          }
        });

        var clearCacheFunction : Function = angular.bind(this, this.clearCache);
        $scope.editorInstance.commands.addCommand({
          name: 'clearCache',
          bindKey: {
            win: 'Ctrl-L',
            mac: 'Command-L',
            sender: 'editor|cli'
          },
          exec: function (env, args, request) {
            clearCacheFunction();
          }
        });

      };
    
      $scope.$watch("settings.currentLanguage", (newHl, oldHl) => {
        if (newHl == oldHl) return;
        if ($scope.currentLanguage && newHl === $scope.currentLanguage.hl) return; //same same
        $timeout(() => { this.loadContent($scope.filter, $scope.settings.currentLanguage); });        
      });

      //load angular templates & messages and such
      this.loadFilter();

      //load topics
      this.loadContentMany(9, 'topic', pglob.RouteData.CurrentLanguage.hl);

      //load existing tags
      this.loadAllTags();

      $(window).on('keydown', (event) => {
          var saveFunction : Function = angular.bind(this, this.saveContent);
          if (event.ctrlKey || event.metaKey) {
              switch (String.fromCharCode(event.which).toLowerCase()) {
              case 's':
                  event.preventDefault();
                  saveFunction();
                  break;
              //case 'f':
              //    event.preventDefault();
              //    alert('ctrl-f');
              //    break;
              //case 'g':
              //    event.preventDefault();
              //    alert('ctrl-g');
              //    break;
              }
          }
      });

      $scope.$on('$destroy', () => {
        $(window).off('keydown')
      });
       
      

    }

    public $onInit(): void {
      if (this.locals) this.loadContent(this.locals.filter, this.$scope.settings.currentLanguage, false);
      if (this.locals && this.locals.filter.FilterString1.toLowerCase() == "topic") { 
        this.$scope.topicCategoryFltr = this.locals.filter.FilterString2.toLowerCase();
      } else {
         this.$scope.topicCategoryFltr = "Blog".toLowerCase();
      }
    }
    
    //typedef for this.locals.x 
    locals : { filter: EditorFilter };

    setRequestOnGoing(value) {
      this.$scope.requestOnGoing = value;
    }

    editMeta(fstring2 : string) : void {
      var f : EditorFilter = this.pageMetaService.getContentFilterFor(fstring2);
      this.loadContent(f);
    }

    isMetaEditable(type : MetaType) : boolean {
      return (this.$scope.meta().RouteData.RouteEntry.RouteParameterStack[0].Editable & type) > 0;
    }

    getUrlKey(title: string): string {
      //return RegExp.Replace(s2, "-+", "-").Trim("-"c)
      var s1 = this.removeDiacritics(title);
      var s2 = s1.replace(new RegExp("[^A-Za-z0-9]", "g"), "-");
      return this.trimChar(s2.replace(new RegExp("-+", "g"), "-"), "-");
    }

    trimChar(s, mask): string {
      while (~mask.indexOf(s[0])) {
        s = s.slice(1);
      }
      while (~mask.indexOf(s[s.length - 1])) {
        s = s.slice(0, -1);
      }
      return s;
    }

    removeDiacritics(title: string): string {
      var map = {
        'a': 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        'e': 'é|è|ê|É|È|Ê',
        'i': 'í|ì|î',
        'o': 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        'u': 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        'c': 'ç|Ç',
        'n': 'ñ|Ñ'
      };

      angular.forEach(map, function (pattern, newValue) {
        title = title.replace(new RegExp(pattern, 'g'), newValue);
      });

      return title;

      //produces typescript error in testing environment, no error when compiled with tsconfig settings, doesn't work in IE11
      //return title.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }

    newContent(hlCode?: string) { 
      this.loadContent(null, hlCode || this.$scope.settings.currentLanguage, true);
    }
    
    loadContent(filter : EditorFilter, hlCode? : string, getNew? : boolean) {   
      if (!getNew && !filter) return;  
      hlCode = hlCode ||  this.$scope.currentLanguage.hl;

      if (this.$scope.editorSession && !this.$scope.editorSession.getUndoManager().isClean()) {
        if (!confirm("Es existieren ungesicherte Änderungen. Verwerfen?")) {
          this.$scope.settings.currentLanguage = this.$scope.currentLanguage.hl;
          return;
        }
      }

      this.setRequestOnGoing(true);

      var hl: ILanguageInfo[] = pglob.RouteData.SupportedLanguages.filter((hl: ILanguageInfo): boolean => { return hl.hl === hlCode });
      if (hl.length < 1) throw "Language not Found";
      
      if (this.$scope.editorInstance) this.$scope.editorInstance.setReadOnly(true);
      
      
      if (getNew) {
        //if someone presse the + button in the blog posts column
        var f = new EditorFilter();
        f.Category = 9;
        f.FilterString1 = "Topic";
        f.FilterString2 = this.$scope.topicCategoryFltr;
        f.IsLanguageIndifferent = false;

        var t = this.$scope.allTags.filter(this.createFilterFor('blog'));

        this.editorService.createContent(this.$scope.currentLanguage, this.$scope.content.ContentType, f, t).then((response) => {
          this.$scope.filter = response.data.ContentFilter;
          this.postLoad(response.data, "erstellt."); 
        });

      } else {
        if (this.$scope.editorInstance) this.$scope.editorInstance.setReadOnly(true);
        if (this.$scope.editorSession) this.$scope.content.Content = this.$scope.editorSession.getValue();

        this.$q.all([
          this.editorService.loadContent(filter, hl[0], this.$scope.content ? this.$scope.content.ContentType : null),
          this.editorService.loadRessources(filter)])
        .then((response) => {
          this.$scope.currentLanguage = hl[0];
          this.$scope.filter = filter;

          
          //process ressources
          this.$scope.ressourceData = <any>{};

          this.$scope.showRessources = response[1].data.length > 0;

          response[1].data.forEach((v: Ressource) => {
            this.$scope.ressourceData[v.Key] = this.$scope.ressourceData[v.Key] || {
              Key: v.Key,
              Scope: v.Scope,
              Desc: v.Desc,
              Text: {},
            }
            this.$scope.ressourceData[v.Key].Text[v.LanguageCode] = v.Text;
          });

          if (response[0].data) {
            this.postLoad(response[0].data, "geladen.");
          } else {
            var type = ContentType.HTML;
            if (this.$scope.content && this.$scope.content.ContentType) type = this.$scope.content.ContentType;
            if (this.$scope.filter.ContentFormat > 0 && this.$scope.filter.ContentFormat == ContentType.MarkDown.charCodeAt(0)) type = ContentType.MarkDown;

            this.editorService.createContent(this.$scope.currentLanguage, type, this.$scope.filter) 
              .then((response) => {
                let urlKey = this.pageMetaService.getPageMeta().RouteData.BasePageUrl;
                if (urlKey) urlKey = urlKey.replace(/\//g, ""); // replace slashes
                let title = `${filter.FilterString2} ${urlKey}`;
                if (title && response.data.ContentMeta) response.data.ContentMeta.Title = title;
                this.$scope.filter = response.data.ContentFilter;
                this.postLoad(response.data, "erstellt.");
              })
              .catch((response) => {
                 alert("Fehler (Err: " + response.status +")");
              });
          }
        });
      }


    }

    private postLoad(c : Content, message : string){
      this.$scope.content = c;
      if (!this.$scope.content.ContentMeta.Tags) this.$scope.content.ContentMeta.Tags = [];

      if (this.$scope.editorSession && c && c.Content && this.$scope.editorSession.getValue() != c.Content) {
        //seems out of sync, so sync. we will loose undo history
        this.$scope.editorSession.setValue(c.Content); 
      }


      if (c.ContentType == ContentType.MarkDown)  { this.$scope.editorSession.setMode("ace/mode/markdown"); }
      if (c.ContentType == ContentType.HTML)      { this.$scope.editorSession.setMode("ace/mode/html"); }
      
      //SQLDate Min "1753-01-01T00:00:00Z"
      //SQLDate Max "9999-12-31T23:59:59.997Z"
      this.$scope.validFromDate = c.ContentMeta.ValidFrom;
      this.$scope.validToDate = c.ContentMeta.ValidTo;
      this.$scope.isValidFromDateSet = c.ContentMeta.ValidFrom && c.ContentMeta.ValidFrom.getFullYear() > 1800;
      this.$scope.isValidToDateSet = c.ContentMeta.ValidTo && c.ContentMeta.ValidTo.getFullYear() < 9000;

      this.$scope.content.ContentMeta.ValidFrom = this.$scope.isValidFromDateSet ? this.$scope.validFromDate : null;
      this.$scope.content.ContentMeta.ValidTo = this.$scope.isValidToDateSet ? this.$scope.validToDate : null;
  
      //focus the ace editor
      if (this.$scope.editorInstance) {
        this.$scope.editorInstance.focus();
      }

      if (this.$mdSidenav('right').isOpen()) { this.toggleRight(); }
      if (this.$mdSidenav('left').isOpen()) { this.toggleLeft(); } 

      this.setRequestOnGoing(false);
      if (this.$scope.editorInstance) this.$scope.editorInstance.setReadOnly(false);

      this.$scope.message = this.$scope.filter.IsLanguageIndifferent ? "Inhalt " : "Sprache '" + this.$scope.currentLanguage.hlFull + "' ";
      this.$scope.message += message;
      this.$timeout(() => {
        this.$scope.message = null;
      }, 2000);
    }

    loadContentMany(categoryId: number, fs1: string, hlCode?: string) {
      if (!fs1) return;
      hlCode = hlCode || this.$scope.currentLanguage.hl;
      this.$scope.loadedTopics = null;

      this.setRequestOnGoing(true);

      var hl: ILanguageInfo[] = pglob.RouteData.SupportedLanguages.filter((hl: ILanguageInfo): boolean => { return hl.hl === hlCode });
      if (hl.length < 1) throw "Language not Found";

      var filter = new EditorFilter();
      filter.FilterString1 = fs1;
      filter.Category = categoryId;

      this.editorService.loadContentMany(filter, hl[0]).then((response) => {
        this.$scope.loadedTopics = response.data;
        return response;
      })

      this.setRequestOnGoing(false);
    }

    updateTopics() {
      this.loadContentMany(9, 'topic', pglob.RouteData.CurrentLanguage.hl);
    }

    saveContent(close?: boolean) {
      this.setRequestOnGoing(true);
      this.$scope.showSaveInProgress = true;      
      if (this.$scope.editorInstance) this.$scope.editorInstance.setReadOnly(true);
      if (this.$scope.editorSession) this.$scope.content.Content = this.$scope.editorSession.getValue();

      var res: Ressource[] = [];
      angular.forEach(this.$scope.ressourceData, (r: IRessourceTableRow, key: string) => {
        this.$scope.supportedLanguages.forEach((hl) => {
          if (r.Text[hl.hl]) {
            res.push(new Ressource(r.Scope, r.Key, r.Desc, hl.hl, r.Text[hl.hl]));
          }
        });
      });

      if (this.$scope.metaEditForm.$invalid) {
        console.log("Error in Meta Edit Form.");
        this.setRequestOnGoing(false);
        this.$scope.showSaveInProgress = false;
        if (!this.$mdSidenav('right').isOpen()) { this.toggleRight(); }
        alert("Fehler beim Speichern. Bitte Eingaben korrigieren.")
        this.$scope.metaEditForm.$setSubmitted();
        return;
      }

      this.$scope.content.ContentMeta.ValidFrom = this.$scope.isValidFromDateSet ? this.$scope.validFromDate : null;
      this.$scope.content.ContentMeta.ValidTo = this.$scope.isValidToDateSet ? this.$scope.validToDate : null;

      this.$q.all([
        this.editorService.saveContent(this.$scope.filter, this.$scope.content, this.$scope.currentLanguage)
        , this.editorService.saveRessources(this.$scope.filter, res)])
        .then((response) => {          
          this.$scope.filter = response[0].data.ContentFilter;
          this.postLoad(response[0].data, "gespeichert.");
          //if (this.$scope.filter.ContentId <= 0) this.$scope.filter.ContentId = response[0].data;



          this.setRequestOnGoing(false);
          this.$scope.showSaveInProgress = false;
          this.$scope.showSaveSuccess = true;
          this.$scope.editorSession.getUndoManager().markClean();
          if (this.$scope.ressourceEditForm) this.$scope.ressourceEditForm.$setPristine();
          if (this.$scope.metaEditForm) this.$scope.metaEditForm.$setPristine();

          this.$timeout(() => {
            this.$scope.showSaveSuccess = false;
            if (close) this.$mdDialog.hide({ filter: this.$scope.filter, data: this.$scope.content.Content });
          }, 2000);  

        })
        .catch((response) => {

          if (response.status == 412) {
            if (confirm('Inhalt wurde zwischenzeitlich auf dem Server geändert. Inhalt neu laden?')) {
              this.editorService.clearCache().then(() => {
                this.loadContent(this.$scope.filter);
              });
            }
          } else {
            alert("Fehler beim Speichern (Err: " + response.status +")");
          }
          
        });         
    }
    

    isTimed(meta: ContentMeta) {
      return this.$scope.isValidFromDateSet || this.$scope.isValidToDateSet;
    }


    clearCache() {
      this.setRequestOnGoing(true);
      this.CacheFactory.destroyAll();
      this.$scope.showSaveInProgress = true;

      this.editorService.clearCache().then(() => {
        this.setRequestOnGoing(false);
        this.$scope.showSaveInProgress = false;
        this.$scope.showCacheSuccess = true;
        this.$timeout(() => {
          this.$scope.showCacheSuccess = false;
        }, 2000);  

      });
    }   

    createMissingContent() {
      this.setRequestOnGoing(true);
      this.$scope.showSaveInProgress = true;

      this.editorService.createMissingContent().then(() => {
        this.loadFilter();
        this.setRequestOnGoing(false);
        this.$scope.showSaveInProgress = false;
        this.$scope.showCacheSuccess = true;
        this.$timeout(() => {
          this.$scope.showCacheSuccess = false;
        }, 2000);  
      });
    }


    

    bindUploadButtons() {
      var imgButton = document.getElementById("submitImageButton");
      var attButton = document.getElementById("submitAttachmentButton");
      if (imgButton) {
       imgButton.addEventListener("click", () => {
          document.getElementById("submitImageInput").click();
        });
      }
      if (attButton) {
        attButton.addEventListener("click", () => {
          document.getElementById("submitAttachmentInput").click();
        });
      } 
    }

    removeFile(type : ContentAttachementType) {
      this.editorService.removeContentFile(this.$scope.content.ContentMeta.Id, type, this.$scope.currentLanguage)
        .then((response) => {
          this.$scope.content.ContentMeta.RowVersion = response.data.ContentMeta.RowVersion; 
          this.$scope.content.ContentMeta.Image = response.data.ContentMeta.Image;
          this.$scope.content.ContentMeta.Attachment = response.data.ContentMeta.Attachment;    
      });

    }

    contentAttSrc(type : ContentAttachementType) {
      var cacheBuster = "";
      if (this.$scope.content && this.$scope.content.ContentMeta && this.$scope.content.ContentMeta.ModifiedAt) {
        cacheBuster = this.$scope.content.ContentMeta.ModifiedAt.getTime().toString();
      }
      return "/svc/blogressource.axd?id=" + this.$scope.content.ContentMeta.Id.toString() + "&type=" + type  + "&lang=" + this.$scope.settings.currentLanguage + '&c=0&cb=' +  cacheBuster;
    }

    loadFilter() {
      this.editorService.loadFilter([14,15]).then((response) => {
        this.$scope.filterTree = <any> {};

        var seen : { [ key : string ] : IFilterTreeBranchL1 } = {};
        
        response.data.forEach((v : EditorFilter) => {
          this.$scope.filterTree[v.Category] = this.$scope.filterTree[v.Category] || [];

          var key = v.Category + "-" + v.FilterString1;

          var add : boolean =  !seen[key];
          seen[key] = seen[key] || { name : v.FilterString1, templates : [] };
          if (add) this.$scope.filterTree[v.Category].push(seen[key]);

          seen[key].templates.push(v);
        });
      });
    }


    closeDialog() {
      if (!this.$scope.editorSession.getUndoManager().isClean() 
        || !this.$scope.ressourceEditForm.$pristine
        || !this.$scope.metaEditForm.$pristine) {
        if (!confirm("Es existieren ungesicherte Änderungen. Verwerfen?")) return;
      }
      this.$mdDialog.hide({ filter: this.$scope.filter, data: this.$scope.content.Content });
    }

    cancelDialog() {
      this.$mdDialog.cancel({ filter: this.$scope.filter });
    }

    toggleRight = this.buildToggler('right');
    toggleLeft = this.buildToggler('left');

    buildToggler(navID: string) {
      return () => {
        this.$mdSidenav(navID)
          .toggle()
        if (this.$mdSidenav('right').isOpen() && this.$scope.uploadButtonsBound == false) {
          this.bindUploadButtons();
          this.$scope.uploadButtonsBound = true;
        }
      }
    }
    tags : ContentTag[] = null;

    createFilterFor(query : string) : (string) => boolean {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(tag: ContentTag) {
        return (tag._lowerdisplayname.indexOf(lowercaseQuery) != -1); 
      };
    }

    loadAllTags($query?: string): ContentTag[] | ng.IPromise<any> {
      if (this.$scope.allTags) {
        if ($query) {
          return this.$scope.allTags.filter(this.createFilterFor($query));
        } else {
          return this.$scope.allTags;
        }
      } 

      return this.editorService.loadTags(this.pageMetaService.getPageMeta().RouteData.CurrentLanguage).then((response) => { 
        this.$scope.allTags = response.data; 
        if ($query) {
          return this.$scope.allTags.filter(this.createFilterFor($query));
        } else {
          return this.$scope.allTags;
        }
      });
    }

    initFromDate() {
      this.$scope.validFromDate = this.$scope.isValidFromDateSet ? new Date(new Date().toDateString()) : null;
    }

    initToDate() {
      this.$scope.validToDate = this.$scope.isValidToDateSet ? new Date(new Date().toDateString()) : null;
    }


  }

}